module.exports = __webpack_public_path__ + "static/media/app-store-gray.9ebdc2c9.png";